import NextLink from 'next/link';
import PropTypes from 'prop-types';

import Button from 'shopper/components/Button';
import Heading from 'shopper/components/Heading';

import { sendEvent } from 'lib/gtag';
import {
  toStoreCouponsLink,
  toStoreOffersLink,
  toSubcategoryLink,
} from 'lib/links';
import placeholder from 'lib/placeholder';

import Section from '../Section';

const MAX_KEYWORDS = 6;

const Keywords = ({ categories, gaEventCategory, storeName, storeParam }) => {
  const onCategoryClick = () => {
    sendEvent({
      action: 'related_categories',
      category: gaEventCategory,
    });
  };

  return (
    <Section>
      <Heading
        as="h2"
        className="flex items-center text-neutral-low-300 dark:text-neutral-high-300"
        size="size5"
      >
        {placeholder('titles.moreOptionsRelatedCategories')}
      </Heading>
      <div className="flex flex-wrap gap-2">
        {storeParam && (
          <>
            <NextLink href={toStoreOffersLink(storeParam)} passHref>
              <Button
                as="a"
                className="rounded-full border border-neutral-high-300"
                size="size4"
                type="neutral-ghost"
                onClick={onCategoryClick}
              >
                Ofertas {storeName}
              </Button>
            </NextLink>
            <NextLink
              href={toStoreCouponsLink(storeParam)}
              prefetch={false}
              passHref
            >
              <Button
                as="a"
                className="rounded-4 border border-neutral-high-300"
                size="size4"
                type="neutral-ghost"
                onClick={onCategoryClick}
              >
                Cupons {storeName}
              </Button>
            </NextLink>
          </>
        )}
        {categories
          .slice(0, MAX_KEYWORDS)
          .map(({ subcategoryId, subcategoryName, subcategorySlug }) => (
            <NextLink
              key={subcategoryId}
              href={toSubcategoryLink(subcategorySlug)}
              prefetch={false}
              passHref
            >
              <Button
                as="a"
                className="rounded-4 border border-neutral-high-300"
                size="size4"
                type="neutral-ghost"
                onClick={onCategoryClick}
              >
                {subcategoryName}
              </Button>
            </NextLink>
          ))}
      </div>
    </Section>
  );
};

Keywords.propTypes = {
  categories: PropTypes.arrayOf(
    PropTypes.shape({
      subcategoryId: PropTypes.number,
      subcategoryName: PropTypes.string,
    })
  ),
  gaEventCategory: PropTypes.string.isRequired,
  storeName: PropTypes.string,
  storeParam: PropTypes.string,
};

export default Keywords;
